import React,{ FC, useEffect } from "react";

const TextInput: FC<any> = ({
  field,
  touched,
  error,
  onValueChange,
  setFieldValue,
  value,
  handleChange,
  ...props
}) => {

    // Preventing from scroll action only for number field
  useEffect(() => {
    if (props?.type && props?.type === "number") {
      const inputElement = document.querySelector(`input[type="number"]`) as HTMLInputElement;
      
      const handleWheel = (e: WheelEvent) => {
        e.preventDefault();
      };

      if (inputElement) {
        inputElement.addEventListener('wheel', handleWheel);
      }

      return () => {
        if (inputElement) {
          inputElement.removeEventListener('wheel', handleWheel);
        }
      };
    }
  }, [props?.type, field]);

  return (
    <>
      <input type="text" 
        className={`form-control ${touched && error?'is-invalid':''}`}
        onKeyUp={({ target: { value } }: any) => onValueChange && onValueChange(value)}
        value={value}
        onChange={handleChange && handleChange(field)}
        {...props}
      />
      {touched && error ? <div className="error_message"><span>{error}</span></div> : null}
    </>
  );
};

export default TextInput;